import React from "react";

const RefundPolicy = () => {
  return (
    <div className="policy-container max-w-4xl mx-auto py-12 px-4 md:px-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">Refund Policy</h1>
      <p className="text-lg text-gray-700 mb-8 leading-relaxed">
        At <strong>Cycle Services</strong>, customer satisfaction is our top priority. 
        We ensure bicycles, parts, accessories, and repair services are of premium quality and meet your expectations. 
        Please read our refund policy carefully before purchase.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. No Refund on Used Products</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        For safety and quality reasons, <strong>refunds or returns are not accepted</strong>{" "}
        once bicycles/parts have been ridden/tested, repaired, or installed.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Damaged, Defective, or Wrong Product</h2>
      <p className="text-lg text-gray-700 mb-4 leading-relaxed">
        If you receive a product that is <strong>damaged, defective, or incorrect</strong>, 
        you may request a replacement or refund under the following conditions:
      </p>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li>Notify us within <strong>7 days</strong> of delivery/receipt.</li>
        <li>Provide clear pictures of the damaged/defective/incorrect item and packaging.</li>
        <li>Items must be unused, uninstalled, with original packaging for eligibility.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Non-Refundable Situations</h2>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li>Orders delayed due to courier or logistics partners (outside our control).</li>
        <li>Change of mind after purchase.</li>
        <li>Items ridden/tested, modified, or installed by the customer.</li>
        <li>Damage from customer misuse or improper maintenance.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Refund Process</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        Once your refund request is approved, the amount will be credited to your original payment method 
        within <strong>7–10 business days</strong>.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Exchanges</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        We replace defective, damaged, or wrong items/models. Contact us with order details and photos.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Contact Us</h2>
      <p className="text-lg text-gray-700 mb-4">For refund or return queries, please reach out to us at:</p>
      <ul className="list-disc list-inside text-lg text-gray-700 space-y-2">
        <li><strong>Phone:</strong> 8082080816</li>
        <li><strong>Email:</strong> info@cyclerentalservices.com</li>
        <li><strong>Address:</strong> Mumbai, MH - 400101, India</li>
      </ul>
    </div>
  );
};

export default RefundPolicy;
